import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
  DOCUMENT,
} from '@angular/core';

import { CeIconRegisteryService } from '@services/core-services/ce-icon-registery.service';

@Component({
  selector: 'app-ce-icon',
  standalone: true,
  template: ` <ng-content></ng-content> `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CeIconComponent implements OnChanges, OnInit {
  private svgIcon: any = SVGElement;
  @Output() custom_click = new EventEmitter<any>();

  @Input()
  size: string | number = '16';

  @Input()
  svg_class: string[] = ['d-flex'];

  @Input()
  name: string = 'store';

  @Input()
  icon: string = 'store';

  @Input()
  disabled: boolean = false;

  constructor(
    private element: ElementRef,
    private ceIconRegistery: CeIconRegisteryService,
    @Optional() @Inject(DOCUMENT) private document: any
  ) {}

  ngOnInit() {
    this.init();
  }

  ngOnChanges(changeRecord: SimpleChanges) {
    this.init();
  }

  private svgElementFromString(svgContent: string): SVGElement {
    const div = this.document.createElement('DIV');
    div.innerHTML = svgContent;
    const svgelement = div.querySelector('svg');
    if (svgelement) {
      svgelement.classList.add('d-flex', ...this.svg_class);
      svgelement.style.width = this.size;
      svgelement.style.height = this.size;
      svgelement.disabled = this.disabled;
      svgelement.addEventListener('click', this.action.bind(this));
    }
    return svgelement || this.document.createElementNS('http://www.w3.org/2000/svg', 'path');
  }

  action() {
    this.custom_click.emit();
  }

  init() {
    if (this.svgIcon) {
      this.element.nativeElement.innerHTML = '';
    }
    let svgData = null;

    if (this.name && !['none', 'no_icon'].includes(this.name) && typeof this.name != 'undefined') {
      this.ceIconRegistery.getIcon(this.name);
    }

    if (this.icon && !['none', 'no_icon'].includes(this.name) && typeof this.name != 'undefined') {
      svgData = this.ceIconRegistery.getIcon(this.name);
    }

    if (svgData) {
      this.svgIcon = this.svgElementFromString(svgData);
      this.element.nativeElement.appendChild(this.svgIcon);
    }
  }
}
